import { z } from "zod";
const CallDirection = {
  Inbound: "inbound",
  Outbound: "outbound"
};
const allCallDirections = [
  CallDirection.Inbound,
  CallDirection.Outbound
];
const callDirectionSchema = z.enum(allCallDirections);
export {
  CallDirection,
  allCallDirections,
  callDirectionSchema
};
//# sourceMappingURL=callDirection.js.map
